require([
    'jquery',
    'base/MbiHelper',
    'base/MbiImageSize',
    'base/MbiMediaQuery',
    'waypoints',
    'project/Templates',
    'base/MbiBrowser',

    'base/Vendor/PictureFill',
    'base/Vendor/rAF'/*,
    'project/Ajax'
    */
], function(
    $,
    _,
    mbiImageSize,
    mbiMq
    ) {
    'use strict'

//$('html').addClass('menuOpen');

    $('#menu').on('click',function(){
        $('html').addClass('menuOpen');
    });
    $('#closenav').on('click',function(){
        $('html').removeClass('menuOpen');
    });

	mbiImageSize.init();

    $(window).on('resize', function(){
        setTimeout(function(){
            mbiImageSize.init();
        },300);
        mbiImageSize.init();
    });

    $('.js_impLink').on('click',function(){
        if($('html').hasClass('imprintOpen') || $('html').hasClass('privacyOpen')){
            $('html').removeClass('imprintOpen');
            $('html').removeClass('privacyOpen');
        } else {
            $('html').addClass('imprintOpen');
            var target = $('.imprint').offset().top;
            $('body, html').animate({
                scrollTop: target
                },300, function() {
            });
        }
    });

    $('.js_prLink').on('click',function(){
        if($('html').hasClass('imprintOpen') || $('html').hasClass('privacyOpen')){
            $('html').removeClass('imprintOpen');
            $('html').removeClass('privacyOpen');
        } else {
            $('html').addClass('privacyOpen');
            var target = $('.privacy').offset().top;
            $('body, html').animate({
                scrollTop: target
                },300, function() {
            });
        }
    });

    function nav() {
        requestAnimationFrame(nav);
        if($(window).scrollTop() > $(window).height() * 0.59) {
            $('#topnav').addClass('fixed');
            $('#langnav').addClass('fixed');
        } else {
            $('#topnav').removeClass('fixed');
            $('#langnav').removeClass('fixed');
        }
    }
    nav();

    function waypoints(wpoint, direction) {

        if($(wpoint[0].element).hasClass('section-intro')) {
            $('html').addClass('menuIconWhite');
        } else {
            $('html').removeClass('menuIconWhite');
            if($(wpoint[0].element).hasClass('section-alternate') || $(wpoint[0].element).hasClass('section-accordion') || $(wpoint[0].element).hasClass('section-maps')){
                $('html').addClass('menuIconBlack');
            } else {
                $('html').removeClass('menuIconBlack');
            }
        }
        if(wpoint[0].element.getAttribute('data-waypoint')) {
            var wp = wpoint[0].element.getAttribute('data-waypoint');
            $('.menu__entry').removeClass('active');
            $('.waypoint').removeClass('active');
            $('.waypoint').removeClass('showText');
            $('.menu__entry[href=#'+wp+']').addClass('active');

            $('.waypoint[data-waypoint-pagination='+wp+']').addClass('active');
            $('.waypoint[data-waypoint-pagination='+wp+']').addClass('showText');
            setTimeout(function(){
                $('.waypoint[data-waypoint-pagination='+wp+']').removeClass('showText');
            },3000);
            //console.log(wpoint[0].element.getAttribute('data-waypoint'),direction);
        }
    }

    var $section = $('.section');
    $section.waypoint(function(direction) {
        // var last = $('.module').last().attr('data-waypoint');
        if (direction === 'down') {
            waypoints($(this), direction);
        }
    }, {offset: '15%'});

    $section.waypoint(function(direction) {
        if (direction === 'up') {
            var offs = 'bottom-in-view';
            waypoints($(this), direction);
        }
    }, {offset: function(){
        //console.log($(this)[0].element.clientHeight);
        //var offsetWaypointUp = $(this)[0].element.clientHeight - 300;
        var offsetWaypointUp = $(this)[0].element.clientHeight - 300;
        return -offsetWaypointUp;
        }
    });

/*
    Clickhandler MENU and creation of waypoints in div "waypoints" FullHeader.php
    CSS in _Navigation.scss
*/

    var ofs = 0; //offset for scroll animation - might change in mobile version

    $('.menu__entry').each(function(index, el) {
        $(document).find($(this).attr('href')).attr('data-waypoint',$(this).attr('href').substring(1));
        var linktext = $(el).text();
        var addWaypoint = '<div class="waypoint" data-waypoint-pagination="'+$(this).attr('href').substring(1)+'"><span class="arrow"></span><span class="text">'+linktext+'</span><span class="border"></span></div>';
        $('.waypoints').append(addWaypoint);
    });

    $('.menu__entry').click(function(e){
        e.preventDefault();
        $('html').removeClass('menuOpen');
        $('.menu__entry').removeClass('active');
        $(this).addClass('active');

        var target = $($(this).attr('href')).offset().top - ofs;
        $('body, html').animate({
            scrollTop: target
            },800, function() {
            /* stuff to do after animation is complete */
        });
    });

    $('[data-waypoint-pagination]').click(function(e){
        e.preventDefault();
        var target = $('#'+$(this).attr('data-waypoint-pagination')).offset().top - ofs;
        $('body, html').animate({
            scrollTop: target
            },800, function() {
            /* stuff to do after animation is complete */
        });
    });

    setTimeout(function(){
        $(window).trigger('resize');
    },1000);
    setTimeout(function(){
        $(window).trigger('resize');
    },3000);
    $(window).on('load',function(){
        $(window).trigger('resize');
    });

});

define("Assets/Js/Footer.js", function(){});

